import { userRoles } from "../components/RoleProtected";

export const InitialMenu = [
    {
        label: 'Home',
        icon: 'home',
        path: '/'
    },
    {
        label: 'Reporting',
        icon: 'clipboard',
        route: '/reporting',
        role: [userRoles.viewFinancialReports, userRoles.viewAuditReports, userRoles.viewUsageReports],
        items: [
            {
                label: 'Sales',
                path: '/reporting/Sales',
                role: [userRoles.viewFinancialReports, userRoles.viewAuditReports, userRoles.viewUsageReports],
            }, {
                label: 'Mobile App',
                path: '/reporting/MobileApp',
                role: [userRoles.viewFinancialReports, userRoles.viewAuditReports],
            }, {
                label: 'ExpressPass',
                path: '/reporting/ExpressPass',
                role: [userRoles.viewUsageReports],
            }, {
                label: 'Codes',
                path: '/reporting/Codes',
                role: [userRoles.viewAuditReports],
            }, {
                label: 'Subscriptions',
                path: '/reporting/Subscriptions',
                role: [userRoles.viewAuditReports, userRoles.viewUsageReports],
            },
        ]
    },
    {
        label: 'Locations',
        icon: 'mapLocation',
        path: '/locations',
    },
    {
        label: 'Customers',
        icon: 'group',
        path: '/customers',
        role: userRoles.viewCustomers,
    },
    {
        label: 'Search by Media',
        icon: 'magnifyingGlass',
        path: '/mediaLookup',
        role: userRoles.viewCustomers,
    },
    {
        label: 'Products',
        icon: 'coins',
        path: '/products',
        role: userRoles.viewProducts,
    },
    {
        label: 'Wash Club',
        icon: 'car',
        path: '/washClub',
        role: userRoles.viewProducts,
    },
    {
        label: 'ExpressPass',
        icon: 'idCard',
        path: '/expressPass',
        role: userRoles.viewCustomers,
    },
    {
        label: 'Codes',
        icon: 'QRcode',
        path: '/codes',
        // role: userRoles.accountConfiguration,
    },
    {
        label: 'Mobile App',
        icon: 'mobileAlt',
        path: '/mobile',
        role: userRoles.viewProducts,
    },
    {
        label: 'Fulfillment',
        icon: 'scale',
        path: '/fulfillment',
        role: userRoles.fulfillment,
    },
    {
        label: 'Settings',
        icon: 'cog',
        path: '/settings'
    },
    {
        label: 'My Account',
        icon: 'user',
        path: '/myAccount',
    },
    {
        label: 'Hamilton',
        icon: 'heading',
        path: '/hamilton'
    }
]